var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaSelectLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20.383,
    height: 19.394,
    viewBox: "0 0 20.383 19.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_1706",
    "data-name": "Rettangolo 1706",
    width: 20.383,
    height: 19.394
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_31",
    "data-name": "Raggruppa 31",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1274",
    "data-name": "Tracciato 1274",
    d: "M28.192,51a10.565,10.565,0,0,0-5.662,1.634,9.818,9.818,0,0,0-3.754,4.352,9.26,9.26,0,0,0-.58,5.6,9.561,9.561,0,0,0,2.789,4.965A10.364,10.364,0,0,0,26.2,70.207a10.676,10.676,0,0,0,5.888-.552,10.1,10.1,0,0,0,4.574-3.571A9.366,9.366,0,0,0,38.383,60.7a9.475,9.475,0,0,0-2.988-6.854A10.473,10.473,0,0,0,28.192,51Zm.425,16.949V66.911a3.3,3.3,0,0,0-1.042-2.394,3.652,3.652,0,0,0-2.516-.992h-.008a2.788,2.788,0,0,1-1.022-.193,2.682,2.682,0,0,1-.866-.551l-2.593-2.469a7.024,7.024,0,0,1,1.235-3.6,7.52,7.52,0,0,1,2.975-2.52,7.964,7.964,0,0,1,7.674.473,1.36,1.36,0,0,1-.775.242H30.458a1.381,1.381,0,0,0-.506.1,1.328,1.328,0,0,0-.429.273,1.252,1.252,0,0,0-.286.408,1.2,1.2,0,0,0-.1.482v.842a1.226,1.226,0,0,1-.387.889,1.356,1.356,0,0,1-.934.368,1.379,1.379,0,0,0-.506.095,1.329,1.329,0,0,0-.43.272,1.254,1.254,0,0,0-.287.408,1.2,1.2,0,0,0-.1.482v.842a1.226,1.226,0,0,0,.387.889,1.356,1.356,0,0,0,.934.368h3.53a1.356,1.356,0,0,1,.934.368,1.226,1.226,0,0,1,.387.889V64.1a1.2,1.2,0,0,0,.1.481,1.255,1.255,0,0,0,.287.408l.708.673A7.781,7.781,0,0,1,28.616,67.949Z",
    transform: "translate(-18 -51)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaSelectLanguage);
export default __webpack_public_path__ + "static/media/icona-select-language.6a5b3d364dc6ad4fa327e6b45bade329.svg";
export { ForwardRef as ReactComponent };